export default __webpack_public_path__ + "static/media/Read-Medium_V1100.7e7e8d2c.woff";